import React from 'react';
export function Testimonials() {
  return <section className="px-4 py-8" data-id="element-222" data-mp="2jyky51bwadma">
      <div className="rounded-3xl border border-hockey-pink/30 bg-hockey-card px-6 py-8 text-center shadow-xl" data-id="element-223" data-mp="3kqns8v0p615z">
        <p className="font-display text-2xl leading-tight text-white" data-id="element-224" data-mp="3fz5sgaaeu6ml">
          Cada partido que juegas sin un{' '}
          <span className="text-hockey-pink" data-id="element-225" data-mp="3azjetzqo6od9">plan detrás</span> es una oportunidad de mejora que no vas a
          recuperar.
        </p>
      </div>
    </section>;
}